import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ChangeDetectorRef, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { takeWhile } from 'rxjs/operators';

import { TableSchema, TableSchemaCriteria } from '../models';
import { databaseList, KeyValue } from '../models/database.model';
import { Store } from '@ngrx/store';
import * as fromStore from '../store';

@Component({
  selector: 'sql-query-header',
  templateUrl: './sql-query-header.component.html'
})
export class SqlQueryHeader implements OnInit, OnDestroy {
  @Input() dataResults: Record<string, any>[];
  @Output() criteriaChangeEvent = new EventEmitter<TableSchemaCriteria>();
  @Input() isEditing: boolean;

  private _alive = true;

  databaseCtrl = new FormControl();
  databases: KeyValue[] = databaseList;

  constructor(private store: Store<fromStore.SqlQueryState>) {}

  ngOnInit(): void {
    this.databaseCtrl.setValue(databaseList[0].value);
    this.databaseCtrl.valueChanges.pipe(takeWhile(() => this._alive)).subscribe((database: string) => {
      this.criteriaChangeEvent.emit({ database: database || databaseList[0].value });
    });

    this.store.dispatch(new fromStore.LoadDatabaseSchemas({ database: databaseList[0].value }));
  }

  ngOnDestroy(): void {
    this._alive = false;
  }
}
